// Components==============
import { hasOneOfRoles } from 'utilities/has-roles';
// =========================

export function usePermission(roles: Roles[]) {
  return hasOneOfRoles(roles);
}
